var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { serialize } from 'object-to-formdata';
import { alertErrorHandler, showSuccess } from '@spike/notifications-action';
import { CUSTOM_CONTENT_NOTIFICATION_GET_ERROR_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_GET_START_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_GET_SUCCESS_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_UPDATE_ERROR_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_UPDATE_START_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_UPDATE_SUCCESS_ACTION_TYPE } from './CustomContentNotificationsActionsTypes';
import { convertToCustomContentNotification, convertToCustomContentNotificationDto } from './CustomContentNotificationsConverter';
var baseUrl = '/custom_content_notifications';
export var updateOrCreateCustomContentNotification = function (apiClientWrapper, customContentNotification) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiClientMethod, customContentNotificatiionData, formData, options, url, response, apiError_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(updateStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    apiClientMethod = customContentNotification.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    customContentNotificatiionData = { custom_content_notification: convertToCustomContentNotificationDto(customContentNotification) };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: true
                    };
                    formData = serialize(customContentNotificatiionData, options, formData);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    url = customContentNotification.id
                        ? "".concat(baseUrl, "/").concat(customContentNotification.key, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(baseUrl, "?marketplace_id=").concat(marketplaceId);
                    return [4 /*yield*/, apiClientMethod(url, formData, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(showSuccess('Notification content updated successfully.'));
                    dispatch(updateSuccess(convertToCustomContentNotification(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    console.error({ apiError: apiError_1 });
                    if (!axios.isCancel(apiError_1)) {
                        message = "Error ".concat(customContentNotification.id ? 'updating' : 'creating', " notification content.");
                        dispatch(updateError(message));
                        alertErrorHandler(apiError_1, dispatch, message);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchCustomContentNotification = function (apiClientWrapper, notificationKey) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, customContentNotification, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(baseUrl, "/").concat(notificationKey, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    customContentNotification = convertToCustomContentNotification(response.data);
                    dispatch(getSuccess(customContentNotification));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    console.error({ apiError: apiError_2 });
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(getError('Error fetching Notification Content'));
                        alertErrorHandler(apiError_2, dispatch, 'Error fetching notification content.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var getStart = function () {
    return {
        type: CUSTOM_CONTENT_NOTIFICATION_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (customContentNotification) {
    return {
        type: CUSTOM_CONTENT_NOTIFICATION_GET_SUCCESS_ACTION_TYPE,
        payload: {
            customContentNotification: customContentNotification
        }
    };
};
var getError = function (error) {
    return {
        type: CUSTOM_CONTENT_NOTIFICATION_GET_ERROR_ACTION_TYPE,
        payload: {
            error: error
        }
    };
};
var updateStart = function () {
    return {
        type: CUSTOM_CONTENT_NOTIFICATION_UPDATE_START_ACTION_TYPE,
    };
};
var updateSuccess = function (customContentNotification) {
    return {
        type: CUSTOM_CONTENT_NOTIFICATION_UPDATE_SUCCESS_ACTION_TYPE,
        payload: {
            customContentNotification: customContentNotification
        }
    };
};
var updateError = function (error) {
    return {
        type: CUSTOM_CONTENT_NOTIFICATION_UPDATE_ERROR_ACTION_TYPE,
        payload: {
            error: error
        }
    };
};
